import { render } from "./OfferItem.vue?vue&type=template&id=5e7169cc&scoped=true"
import script from "./OfferItem.vue?vue&type=script&lang=js"
export * from "./OfferItem.vue?vue&type=script&lang=js"

import "./OfferItem.vue?vue&type=style&index=0&id=5e7169cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e7169cc"

export default script